export const getParams = (connection, playbook) => {
  return [
    ...(connection.endpointSchema?.params ?? []),
    ...(connection.connectionTemplate?.params ?? []),
    ...(playbook?.params ?? []),
  ];
};
